import styled from 'styled-components';

export const RedeemPointContainerStyled = styled.div`
  .help_panel {
    margin-bottom: 1rem;
    border: 1px solid #dbe4f0;
    border-radius: 6px;
    background: #f7f9fc;
    overflow: hidden;
    .help_head {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 14px;
      cursor: pointer;
      user-select: none;
      color: #3c5a80;
      .help_head_text {
        font-size: 14px;
      }
      .help_toggle {
        margin-left: auto;
        font-size: 13px;
        text-decoration: underline;
      }
    }
    .help_body {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      padding: 0 14px 14px 14px;
      font-size: 13px;
      line-height: 1.7;
      color: #435466;
      .help_col {
        flex: 1;
        min-width: 220px;
        .help_col_title {
          color: #2b4a70;
          margin-bottom: 2px;
        }
        .help_dim {
          color: #7d8fa3;
        }
      }
      .help_note_row {
        width: 100%;
        padding-top: 10px;
        border-top: 1px solid #e2eaf4;
        color: #435466;
      }
    }
  }
  .btn_bulk {
    width: 220px;
    margin-bottom: 1rem;
  }
  .filter_layout {
    margin-bottom: 1rem;
  }
`;
